import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, exhaustMap, filter, map, of, tap, withLatestFrom } from 'rxjs';
import { Injectable } from '@angular/core';
import { DataService } from '../../services/data-api.service';
import { ApiService } from 'src/app/services/api.service';
import { Store } from '@ngrx/store';
import { getItemConfigurationInputResponseFailure, getItemConfigurationInputResponseSuccess, loadItemConfigurationInputFromRequest } from './item-configuration-input.actions';
import { selectItemConfigurationInputRequest } from './item-configuration-input.selector';
import { ItemConfigurationInputRequest, ItemConfigurationInputResponse } from 'src/app/models/pricing-view-models';


/**
 * ProjectsEffects class is responsible for handling the side effects related to projects.
 * It contains methods to load active projects and search projects based on a request.
 */
@Injectable()
export class ItemConfigurationInputEffects {
  /**
   * Effect to load all pricing for search request - currently on by Product Model.
   * @returns An observable of actions.
   */
  loadItemConfigurationInputsFromRequest$ = createEffect(() => {
      return this.actions$.pipe(
        ofType(loadItemConfigurationInputFromRequest),
        withLatestFrom(this.store.select(selectItemConfigurationInputRequest)),

        //will not proceed past this point unless true is returned
        filter (([_, itemConfigurationInputRequest]) => {
          //console.log('loadItemConfigurationInputsFromRequest$ filtering',itemConfigurationInputRequest);
          let rtn: boolean = false;
          if (itemConfigurationInputRequest?.itemConfigurationInputRequest?.ProductModelName !== null && itemConfigurationInputRequest?.itemConfigurationInputRequest?.ProductModelName !== undefined) {
            rtn = true;
          } else if (itemConfigurationInputRequest?.itemConfigurationInputRequest?.ProjectScheduleLineItemId !== undefined && itemConfigurationInputRequest?.itemConfigurationInputRequest?.ProjectScheduleLineItemId > 0) {
            rtn = true;
            //console.log('loadItemConfigurationInputsFromRequest$ is not happening',itemConfigurationInputRequest);
          } 
          return rtn;
        }), // prevents running without product model
       
        exhaustMap(([_, requestState]) => {
          //console.log('loadItemConfigurationInputsFromRequest$ is happening',requestState.itemConfigurationInputRequest);
          //console.log('loadAllPricingInputsForSearchRequest$ is happening',pricingInputRequest);
          return this.apiService.post<ItemConfigurationInputRequest, ItemConfigurationInputResponse>('projectschedulelineitem/getitemconfigurationinputs', requestState.itemConfigurationInputRequest)
            .pipe(
                //tap(response => console.log('Search PricingInputs Response:', response)),
                map((itemConfigurationInputResponse) => {
                    //console.log('Search PricingInputs Response:', pricingInputResponse);
                    //response.Projects.forEach((project) => project.Brand = brands.find(brand => brand.BrandId === project.BrandId))
                    return getItemConfigurationInputResponseSuccess({ itemConfigurationInputRequest: requestState.itemConfigurationInputRequest, itemConfigurationInputResponse: itemConfigurationInputResponse })
                  }
                ),
                catchError((error) =>
                  of(getItemConfigurationInputResponseFailure({ error }))
                )
            );

        }
        )
      )
    }
  );

  constructor(private store: Store, private actions$: Actions, private dataService: DataService, private apiService: ApiService) {
  }
}
